import BasePermissionsMixin from '@/app/shared/mixins/BasePermissionsMixin';

export default {
    mixins: [
        BasePermissionsMixin,
    ],
    data() {
        return {
            pageID: null,
        }
    },
    computed: {
    },
};